import { Instance, types } from 'mobx-state-tree';

export const DeliveryTime = types.model('DeliveryTime', {
    id: types.number,
    name: types.string
  });
  
export type DeliveryTime = Instance<typeof DeliveryTime>;